/**
 * Versions minimale et conseillée des apps du mode `?demo` : en mémoire,
 * mutées comme l'API (révision, conseillée jamais sous la minimale). iOS est
 * réglé, Android n'a encore aucune exigence.
 */
import { CONSEILLEE_COHERENTE, PLATEFORMES_APP } from '@artosera/shared';
import type { ExigencesPlateforme, ExigencesVersions, PlateformeApp } from '@artosera/shared';
import { ApiError } from './api.js';
import type { VersionsAppsVue } from '../types.js';

let exigences: ExigencesVersions = {
  ios: {
    minimale: '1.2',
    conseillee: '1.4.0',
    urlBoutique: 'https://apps.apple.com/fr/app/artosera/id0000000000',
  },
  android: { minimale: null, conseillee: null, urlBoutique: null },
};
let revision = 3;

const vue = (): VersionsAppsVue => structuredClone({ exigences, revision });

export const demoVersionsApps = {
  obtenir: vue,
  modifier(
    plateforme: PlateformeApp,
    reglage: ExigencesPlateforme,
    revisionLue: number,
  ): VersionsAppsVue {
    if (!PLATEFORMES_APP.includes(plateforme)) {
      throw new ApiError(404, 'ressource.introuvable', 'Plateforme inconnue.');
    }
    if (!CONSEILLEE_COHERENTE[0](reglage)) {
      throw new ApiError(400, 'validation.invalide', CONSEILLEE_COHERENTE[1].message);
    }
    if (revisionLue !== revision) {
      throw new ApiError(409, 'conflit.version', 'Les versions des apps ont changé entre-temps.', {
        raison: 'revision_versions_perimee',
      });
    }
    exigences = { ...exigences, [plateforme]: { ...reglage } };
    revision += 1;
    return vue();
  },
};
